import type { App, Component } from 'vue';

export function registerStoryblokComponents(
  app: App,
  storyblokComponents: Record<string, Component>
): void {
  Object.entries(storyblokComponents).forEach(([componentName, component]) => {
    app.component(componentName, component);
  });
}
